export default __webpack_public_path__ + "static/media/Essence of Courage.029d9452.jpg";